import { toNormalizedMessage } from '@/shared/utils/sentry/clientIgnoreRules/stringMatchers';
import {
  ClientSentryEventContext,
  ClientSentryIgnoreRule,
} from '@/shared/utils/sentry/clientIgnoreRules/types';

const OUT_OF_MEMORY_UNHANDLED_REJECTION_MESSAGE =
  'non-error promise rejection captured with value: out of memory';
const OUT_OF_MEMORY_MESSAGE = 'out of memory';

const isExactWrappedOutOfMemoryMessage = (message: unknown): boolean =>
  toNormalizedMessage(message) === OUT_OF_MEMORY_UNHANDLED_REJECTION_MESSAGE;

const isExactOutOfMemoryValue = (message: unknown): boolean =>
  toNormalizedMessage(message) === OUT_OF_MEMORY_MESSAGE;

const hasActionableContext = ({
  hasExceptionStacktrace,
  hasAppFrameInStacktrace,
}: ClientSentryEventContext): boolean =>
  hasExceptionStacktrace || hasAppFrameInStacktrace;

export const nonErrorOutOfMemoryUnhandledRejectionRule: ClientSentryIgnoreRule =
  {
    id: 'non-error-out-of-memory-unhandled-rejection',
    references: ['FTR-2614'],
    reason:
      'Known raw browser rejection without usable stack/app-frame context',
    matches: (context) => {
      if (context.firstExceptionType !== 'UnhandledRejection') {
        return false;
      }

      if (hasActionableContext(context)) {
        return false;
      }

      return (
        isExactWrappedOutOfMemoryMessage(context.serializedMessage) ||
        isExactOutOfMemoryValue(context.originalExceptionMessage)
      );
    },
  };
